import script from "./EstadisticasEjercitoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./EstadisticasEjercitoView.vue?vue&type=script&setup=true&lang=ts"

import "./EstadisticasEjercitoView.vue?vue&type=style&index=0&id=3353890c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3353890c"]])

export default __exports__